// Helpers de formatação de data/hora reaproveitados por várias telas —
// centralizados aqui depois de terem sido copiados um por um em Aprovacoes,
// Dashboard, HistoricoPonto, MeuHistorico, FechamentoMensal, BaterPonto,
// Atestados e Auditoria (todos com o corpo idêntico).

// "1.15h" lido por qualquer humano parece "1h15" — mas hora decimal não
// funciona assim (0.15h são 9min, não 15). Sempre HH:MM pra não confundir.
export function formatarHoras(horasDecimal) {
  const valor = horasDecimal || 0;
  const totalMin = Math.round(Math.abs(valor) * 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  const sinal = valor < 0 ? "-" : "";
  return `${sinal}${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function horaLocal(iso) {
  return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

export function dataLocal(data) {
  return new Date(data + "T12:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function dataHoraLocal(iso) {
  return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
